var map = {
	"./webhosting/upgrade-details.json": "K6Gv"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YDv0";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/data ^\.\/.*\/upgrade\-details\.json$
// module id = YDv0
// module chunks = 0